import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';

import { graphqlApi } from '../../config';

let browserApolloClient: ApolloClient<NormalizedCacheObject> | undefined;

// Only public olympus queries are used here, so no auth link is needed
const createApolloClient = () =>
  new ApolloClient({
    ssrMode: typeof window === 'undefined',
    link: new HttpLink({ uri: graphqlApi }),
    cache: new InMemoryCache(),
  });

// A fresh client per server request so cached data is never shared between requests
export const getApolloClient = (): ApolloClient<NormalizedCacheObject> => {
  if (typeof window === 'undefined') return createApolloClient();

  if (!browserApolloClient) browserApolloClient = createApolloClient();

  return browserApolloClient;
};
